// Mirror of App\Enums\DraftState (campdraftone-api)
export const DRAFT_STATE_OPEN = 1
export const DRAFT_STATE_CLOSED = 3
export const DRAFT_STATE_FINALISE = 5
export const DRAFT_STATE_ON_HOLD = 6



// WEBPACK FOOTER //
// ./src/constants/draftStates.js